export default __webpack_public_path__ + "static/media/header-logo.cb1ea5e9.png";